export function exists(val) {
  return typeof val !== 'undefined';
}



// WEBPACK FOOTER //
// /Users/jamess/webdev/react-projects/materialish/docs/src/vendor/react-over/identification.js